module.exports = __webpack_public_path__ + "img/motorbike-front-left.ba71dadc.svg";